<template>
  <Navbar homeview logourl="/rental/home" />

  <section id="abonamentData">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>Informacje o abonamencie</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-12" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <div v-if="Array.isArray(userDevices) && userDevices.length > 0">
              <div v-for="(userDevice, index) in userDevices">
                <div class="tile" style="border: 1px solid #f2f2f2">
                  <div class="text-center">
                    <h3>
                      Numer seryjny urządzenia:
                      {{
                        userDevice.serial2 == null
                          ? userDevice.serial
                          : userDevice.serial2
                      }}
                    </h3>

                    <div v-if="userDevice.hwid == 'NEX/1.0'">
                      <img
                        src="../assets/images/NEX_front.png"
                        style="width: 5rem; align-items: center"
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <img
                        src="../assets/images/cdif3rental.png"
                        style="width: 5rem"
                        alt=""
                      />
                    </div>
                  </div>

                  <div class="row gy-4">
                    <div
                      class="col-lg-4"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div class="tile">
                        <div class="col-md-12 text-center">
                          <div>
                            Data rozpoczęcia abonamentu:
                            <b>{{ userDevice.start_date.substring(0, 10) }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-4"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div class="tile">
                        <div class="col-md-12 text-center">
                          <div>
                            {{
                              userDevice.subscriptionDaysLeft >= 0
                                ? "Data wygaśnięcia abonamentu:"
                                : "Twój abonament skończył się:"
                            }}
                            <b>{{ userDevice.expire_date.substring(0, 10) }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-4"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div class="tile">
                        <div class="col-md-12 text-center">
                          <div v-if="userDevice.subscriptionDaysLeft >= 0">
                            <span
                              v-html="
                                subscriptionDaysLeftMessage(
                                  userDevice.subscriptionDaysLeft
                                )
                              "
                            ></span>
                          </div>
                          <div v-else>
                            <b>Brak abonamentu</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div v-if="userDevice.subscriptionDaysLeft < 0">
                    <Alert
                      v-if="
                        userDevice.subscriptionDaysLeft >= -deviceReturnDays
                      "
                      alert-type="alert-warning"
                      :alert-text="
                        returnDeviceDaysMessage(userDevice.subscriptionDaysLeft)
                      "
                    />
                    <div v-else class="alert alert-danger text-center">
                      <b
                        >Czas na zwrot urządzenia lub przedłużenie abonamentu
                        minął
                        {{
                          -(userDevice.subscriptionDaysLeft + deviceReturnDays)
                        }}
                        {{
                          -(
                            userDevice.subscriptionDaysLeft + deviceReturnDays
                          ) === 1
                            ? "dzień"
                            : "dni"
                        }}
                        temu. Kara za przetrzymanie urządzenia wynosi obecnie
                        {{
                          -(
                            userDevice.subscriptionDaysLeft + deviceReturnDays
                          ) * 50
                        }}
                        zł netto ({{
                          round2dec(
                            -(
                              userDevice.subscriptionDaysLeft + deviceReturnDays
                            ) *
                              50 *
                              vatRatio
                          )
                        }}
                        zł brutto)</b
                      >
                    </div>
                  </div>
                  <div
                    v-if="userDevice.subscriptionDaysLeft >= -deviceReturnDays"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div class="">
                      <div class="row">
                        <div
                          class="col-md-6 d-flex align-items-center justify-content-center"
                        >
                          <h4
                            v-if="userDevice.subscriptionDaysLeft >= 0"
                            class="text-center aboinfo"
                          >
                            Abonament zaraz się kończy?
                          </h4>
                          <h4 v-else class="text-center aboinfo">
                            Abonament już się skończył?
                          </h4>
                        </div>

                        <div class="col-md-6">
                          <div class="text-center">
                            <button
                              v-if="userDevice.subscriptionDaysLeft >= 0"
                              class="btn-standard"
                              @click="
                                onExpandSubscriptionButtonClick(index, 1, false)
                              "
                            >
                              Przedłuż abonament
                            </button>
                            <button
                              v-else
                              class="btn-standard"
                              @click="
                                onExpandSubscriptionButtonClick(index, 1, false)
                              "
                            >
                              Zamów abonament
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="userDevice.subscriptionDaysLeft >= 0">
                        <div class="row">
                          <div
                            class="col-lg-6 col-md-12 d-flex align-items-center justify-content-center"
                          >
                            <div class="text-center">
                              <h4 class="aboinfo">
                                Pobierz oprogramowanie systemu CDIF/3
                              </h4>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-12 text-center">
                            <div class="row">
                              <div class="col-lg-6">
                                <form :action="hostname" method="post">
                                  <input
                                    type="hidden"
                                    name="action"
                                    :value="Request.DownloadSoftware"
                                  />
                                  <input
                                    type="hidden"
                                    name="id"
                                    :value="softId"
                                  />
                                  <input
                                    type="hidden"
                                    name="serial"
                                    :value="userDevice.serial"
                                  />
                                  <button
                                    class="btn-standard"
                                    type="submit"
                                    formmethod="post"
                                  >
                                    Oprogramowanie
                                  </button>
                                </form>
                              </div>
                              <div class="col-lg-6 col-md-12">
                                <form :action="hostname" method="post">
                                  <input
                                    type="hidden"
                                    name="action"
                                    :value="Request.DownloadKey"
                                  />
                                  <input
                                    type="hidden"
                                    name="serial"
                                    :value="userDevice.serial"
                                  />
                                  <input
                                    type="hidden"
                                    name="key"
                                    :value="deviceKey"
                                  />
                                  <button
                                    class="btn-standard"
                                    type="submit"
                                    formmethod="post"
                                  >
                                    Klucz
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="row gy-4 mt-3 d-flex justify-content-center"
                        >
                          <Alert
                            v-if="getOSData() !== 'Windows'"
                            alert-type="alert-warning"
                            alert-text="<b>Plik instalacyjny programu CDIF/3 nie jest obsługiwany na Twoim systemie operacyjnym</b>"
                          />
                          <Alert
                            v-if="getOSData() === null"
                            alert-type="alert-warning"
                            alert-text="<b>Nie udało się określić Twojego systemu operacyjnego. Plik instalacyjny programu CDIF/3 może nie być obsługiwany na Twoim systemie operacyjnym</b>"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              <div v-if="userDevices.length > 0 && userHasActiveDevice">
                <div class="row justify-content-center">
                  <div class="col-lg-4 col-md-12 text-center">
                    <h4 class="aboinfo">Potrzebujesz kolejne urządzenie?</h4>
                  </div>

                  <div class="col-lg-4 col-md-12 text-center">
                    <button
                      type="button"
                      id="button1"
                      class="btn-standard"
                      @click="onExpandSubscriptionButtonClick(null, 0, true)"
                    >
                      Zamów następne urządzenie
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="!Array.isArray(userDevices)">
              <div v-if="noAssignedDeviceInfo">
                <Alert
                  :key="alertKey"
                  alert-type="alert-warning"
                  alert-text="Brak przypisanych urządzeń do konta. Zamów urządzenie z abonamentem przyciskiem poniżej.
                Zgodnie z Regulaminem usługi pierwsza płatność traktowana jest jako weryfikacja danych użytkownika.
                Dane podane w systemie muszą być zgodne z danymi w przelewie przychodzącym."
                  class="m-1"
                />
                <div class="text-center">
                  <button
                    type="button"
                    id="button1"
                    class="btn-standard"
                    @click="onExpandSubscriptionButtonClick(null, 0, false)"
                  >
                    Zamów urządzenie z abonamentem
                  </button>
                </div>
              </div>
              <Alert
                v-if="noDeviceDataInfo"
                :key="alertKey"
                alert-type="alert-danger"
                alert-text="Błąd przy pobieraniu danych"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="userData">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Moje dane</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <div class="card-body">
              <div v-if="userData === null">
                <strong>Ładowanie danych...</strong><br />
                <div
                  class="spinner-border ms-auto"
                  role="status"
                  aria-hidden="true"
                  style="color: #50d8af"
                ></div>
              </div>
              <div v-else>
                <h4>Dane użytkownika</h4>
                <div class="card-body">
                  <ul class="list-group">
                    <p class="card-text">
                      <b>Imię i nazwisko / nazwa firmy</b>: {{ userData.name }}
                    </p>
                    <p class="card-text">
                      <b>Adres</b>: {{ userData.address }}
                    </p>
                    <p class="card-text">
                      <b>Kod pocztowy i miasto</b>: {{ userData.postal }}
                      {{ userData.city }}
                    </p>
                    <p class="card-text"><b>NIP</b>: {{ userData.vat }}</p>
                    <p class="card-text">
                      <b>Nr REGON</b>: {{ userData.regon }}
                    </p>
                    <p class="card-text">
                      <b>Numer telefonu</b>: {{ userData.phone }}
                    </p>
                    <div
                      v-if="
                        userData.phone_mobile === null ||
                        userData.phone_mobile === undefined ||
                        userData.phone_mobile === ''
                      "
                    ></div>
                      <p class="card-text" v-else>
                        <b>Telefon dodatkowy</b>: {{ userData.phone_mobile }}
                      </p>
                    <p class="card-text"><b>E-mail</b>: {{ userData.email }}</p>
                    <p class="card-text">
                      <b>Nazwa użytkownika</b>: {{ userData.username }}
                    </p>
                  </ul>
                  <div class="text-center mt-3">
                    <button
                      class="btn-standard"
                      @click="onEditUserDataButtonClick"
                    >
                      Edytuj dane / zmień hasło
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <h4>Dane autoryzacyjne</h4>
            <div class="card-body">
              <div class="card-body">
                <ul class="list-group">
                  <p class="card-text">
                    <b>ID użytkownika</b>: {{ userData.useridnum }}
                  </p>
                  <p class="card-text"><b>Pin</b>: {{ userData.pin }}</p>
                  <!--                        <p class="card-text"><b>Numer identyfikacyjny</b> (podaj go swojemu opiekunowi handlowemu): {{ userData.rental_user_ident }}</p>-->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="payment">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Historia płatności</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-12" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <div
              class="d-flex justify-content-center"
              v-if="
                getUserOrderHistory === null ||
                getUserOrderHistory === undefined ||
                (Array.isArray(getUserOrderHistory) &&
                  getUserOrderHistory.length === 0)
              "
            >
              <strong>W historii nie ma żadnych zapisanych płatności</strong
              ><br />
            </div>
            <div v-else>
              <!-- zamówienia z paginacją -->
              <UserOrderHistoryData :user-order-history-data="getUserOrderHistory" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="contact">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Kontakt</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <h4>Numer telefonu</h4>
            <div class="card-body">
              <blockquote class="blockquote mb-0" style="font-size: medium">
                <p>
                  <b>Infolinia </b><br />
                  <a href="tel:+48587321949">+48 58 732 19 49</a>
                </p>
                <p class="textContact">
                  Opłaty za połączenia zależne są od taryfy Twojego operatora
                  oraz wybranego abonamentu telefonicznego. Sprawdź stawki
                  swojego operatora aby uzyskać więcej szczegółów.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <h4>E-mail</h4>
            <div class="card-body">
              <blockquote class="blockquote" style="font-size: medium">
                <p>
                  <b>Skrzynka ogólna</b><br />
                  <a href="mailto:info@cdif3.com">info@cdif3.com</a> - tu należy
                  kierować wszelką korespondencję dotyczącą CDIF/3.
                </p>
                <p>
                  <b>Pomoc - wsparcie techniczne</b><br />
                  <a href="mailto:pomoc@cdif3.com">pomoc@cdif3.com</a> - tu
                  należy kierować zapytania o pomoc i wsparcie, zgłoszenia
                  problemów oraz wszelkie uwagi dotyczące prawidłowości
                  działania systemu CDIF/3.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
      <div class="row gy-4 mt-2">
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <h4>Dane adresowe</h4>
            <div class="card-body">
              <blockquote class="blockquote" style="font-size: medium">
                <p>
                  Axes System sp. z o.o.<br />
                  ul. Raciborskiego 35<br />
                  80-215 Gdańsk<br />
                  NIP: 9571067410<br />
                  Polska
                </p>
              </blockquote>
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <h4>Godziny pracy</h4>
            <div class="card-body">
              <blockquote class="blockquote" style="font-size: medium">
                <p>
                  Nasza firma pracuje w dni robocze od poniedziałku do piątku, w
                  godzinach <b>od 8:00 do 16:00.</b> W tych godzinach działa
                  także Wsparcie Techniczne dla użytkowników systemu CDIF/3.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { RequestResult } from "@/utils/requestResult";
import Alert from "@/components/Alert.vue";
import { Request } from "@/utils/request";
import store from "@/store";
import { makeRequest, round2dec } from "@/utils/helpers";
import { useGlobals } from "@/main";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";
import UserOrderHistoryData from "@/components/UserOrderHistoryData.vue";

export default {
  components: {
    Navbar,
    Footer,
    Alert,
    UserOrderHistoryData,
  },

  data() {
    return {
      userData: null,
      name: null,
      address: null,
      postal: null,
      place: null,
      email: null,
      phone: null,
      mobile: null,
      vat: null,
      regon: null,
      usr: null,
      userDevices: null,
      paymentDate: null,
      paymentAmount: null,
      orderdate: null,
      rental_user_ident: null,

      getUserOrderHistory: null,

      deviceKey: null,
      softId: null,

      noAssignedDeviceInfo: false,
      noDeviceDataInfo: false,

      alertKey: 0,
    };
  },

  async created() {
    await this.getUserSubscriptionData(); // dane o urządzeniu pobieramy przed renderem strony, inaczej będzie pusto
    await this.getUserData();
    await this.getOrderData();
    await this.getLastEditionData();
  },

  async mounted() {
    // po powrocie do strony głównej z zamówienia czyścimy dane w storze
    store.commit("SetRentalDeviceIndex", null);
    store.commit("SetOrderId", null);
    store.commit("SetDotPay", null);
    store.commit("SetOrderSuccess", null);
    store.commit("SetTraditionalTransfer", null);
    store.commit("SetOrderContinuation", null);
    store.commit("SetOrderAmount", null);
    store.commit("ResetDotPayPaymentCounter");
    store.commit("SetDotPayPaymentLink", null);
    store.commit("SetNextDeviceTrigger", null);
  },

  computed: {
    Request() {
      return Request;
    },

    userHasActiveDevice() {
      let deviceActive = true;

      // jeżeli będzie jakiekolwiek urządzenie bez aktywnego abo i po okresie karencji lub w okresie karencji to zwróć false
      for (const device of this.userDevices) {
        if (device.subscriptionDaysLeft < 0) {
          deviceActive = false;
          break;
        }
      }

      return deviceActive;
    },
  },

  methods: {
    round2dec,

    async getUserData() {
      let data = {
        action: this.request.GetUser,
      };

      let getUserResponse = await makeRequest(data);

      switch (getUserResponse.data.error) {
        case RequestResult.OK: {
          this.userData = getUserResponse.data.data;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
        case RequestResult.GeneralError: {
          // userData bedzie nullem w tym przypadku
          // kręci się Ładowanie danych, nic nie robimy, a wyświetlać info o błędzie za bardzo nie ma sensu (chyba)
          break;
        }
      }
    },

    async getUserSubscriptionData() {
      let data = {
        action: this.request.GetDeviceData,
      };

      let getUserSubscriptionDataResponse = await makeRequest(data);

      this.userDevices = getUserSubscriptionDataResponse.data.data;

      if (!Array.isArray(this.userDevices))
        switch (getUserSubscriptionDataResponse.data.error) {
          case RequestResult.InvalidCookie:
          case RequestResult.CookieExpired: {
            this.$router.push(this.routePath.Login);
            break;
          }
          case RequestResult.NoAssignedDevice: {
            this.noAssignedDeviceInfo = true;
            break;
          }
          case RequestResult.GeneralError: {
            this.noDeviceDataInfo = true;
            break;
          }
        }

      this.alertKey += 1;
    },

    async getOrderData() {
      let data = {
        action: this.request.getUserOrderHistory,
      };

      let getOrderDataResponse = await makeRequest(data);

      this.getUserOrderHistory = getOrderDataResponse.data.data;

      if (!Array.isArray(this.getUserOrderHistory))
        switch (getOrderDataResponse.data.error) {
          case RequestResult.InvalidCookie:
          case RequestResult.CookieExpired: {
            this.$router.push(this.routePath.Login);
            break;
          }
          case RequestResult.GeneralError: // można by to pominąć ale przynajmniej widać co zwraca API - i tak mamy info o braku zamówień
            break;
        }
    },

    async getLastEditionData() {
      let lastEditionData = await makeRequest(
        this.hostname + `?action=${this.request.GetLastEditionData}`,
        "GET"
      );

      switch (lastEditionData.data.error) {
        case RequestResult.OK: {
          this.deviceKey = parseInt(lastEditionData.data.data.KEY);
          this.softId = lastEditionData.data.data.DLID;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
        case RequestResult.GeneralError: {
          // można by to pominąć ale przynajmniej widać co zwraca API
          break;
        }
      }
    },

    getOSData() {
      let os = null;

      if (navigator.userAgent.indexOf("Win") !== -1) os = "Windows";
      if (navigator.userAgent.indexOf("Mac") !== -1) os = "Mac";
      if (navigator.userAgent.indexOf("Linux") !== -1) os = "Linux";
      if (navigator.userAgent.indexOf("Android") !== -1) os = "Android";
      if (navigator.userAgent.indexOf("like Mac") !== -1) os = "iOS";

      return os;
    },

    subscriptionDaysLeftMessage(subscriptionDaysLeft) {
      let messageLastDayLeft = `Pozostał Ci <b>ostatni</b> dzień abonamentu`;
      let messageOneDayLeft = `Pozostał Ci <b>1</b> dzień abonamentu`;
      let messageOverOneDayLeft = `Pozostało Ci <b>${subscriptionDaysLeft}</b> dni abonamentu`;

      switch (subscriptionDaysLeft) {
        case 0:
          return messageLastDayLeft;
        case 1:
          return messageOneDayLeft;
        default:
          return messageOverOneDayLeft;
      }
    },

    returnDeviceDaysMessage(subscriptionDaysLeft) {
      let messageLastDayLeft = `<b">Abonament skończył się ${Math.abs(
        subscriptionDaysLeft
      )} dni temu. Masz ostatni dzień na zwrot urządzenia lub zamówienie abonamentu bez opłaty aktywacyjnej.</b>`;
      let messageOneDayAgo = `<b>Abonament skończył się 1 dzień temu. Zwróć urządzenie lub zamów abonament bez opłaty aktywacyjnej.</b>`;
      let messageOverOneDayAgo = `<b>Abonament skończył się ${Math.abs(
        subscriptionDaysLeft
      )} dni temu. Zwróć urządzenie lub zamów abonament bez opłaty aktywacyjnej.</b>`;

      switch (subscriptionDaysLeft) {
        case -useGlobals().deviceReturnDays:
          return messageLastDayLeft;
        case -1:
          return messageOneDayAgo;
        default:
          return messageOverOneDayAgo;
      }
    },

    async onEditUserDataButtonClick() {
      this.$router.push(this.routePath.EditUserData);
    },

    onExpandSubscriptionButtonClick(
      serialNumberIndex,
      orderContinuation,
      nextDevice
    ) {
      store.commit("SetRentalDeviceIndex", serialNumberIndex);
      store.commit("SetOrderContinuation", orderContinuation);
      store.commit("SetNextDeviceTrigger", nextDevice);

      this.$router.push(this.routePath.SubscriptionHandle);
    },
  },
};
</script>

<style scoped>
.tile .icon {
  float: left;
}

#abonamentData .aboinfo {
  margin: 0;
}

#userData p {
  line-height: 15px;
}

#terms .tile h4 {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 22px;
}
#terms .tile h4 a {
  color: #444;
}
#terms .tile p {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 24px;
}

tr td {
  justify-content: center;
  align-items: center;
  justify-items: center;
}

@media (max-width: 767px) {
  .tile {
    margin-bottom: 20px;
  }
  .tile .icon {
    float: none;
    text-align: center;
    padding-bottom: 15px;
  }

  #terms .tile h4,
  #terms .tile p {
    margin-left: 0;
    text-align: center;
  }
}
</style>
